var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.7688 6.71387H13.2312C15.5886 6.71387 17.5 8.58307 17.5 10.8885V15.8254C17.5 18.1308 15.5886 20 13.2312 20H4.7688C2.41136 20 0.5 18.1308 0.5 15.8254V10.8885C0.5 8.58307 2.41136 6.71387 4.7688 6.71387ZM8.99492 15.3295C9.49283 15.3295 9.88912 14.9419 9.88912 14.455V12.2489C9.88912 11.772 9.49283 11.3844 8.99492 11.3844C8.50717 11.3844 8.11088 11.772 8.11088 12.2489V14.455C8.11088 14.9419 8.50717 15.3295 8.99492 15.3295Z",
    fill: "url(#paint0_linear_458_2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5227 5.39595V6.86667C14.1671 6.7673 13.7911 6.71761 13.405 6.71761H12.7445V5.39595C12.7445 3.37868 11.0679 1.73903 9.00509 1.73903C6.94233 1.73903 5.2657 3.36874 5.25554 5.37608V6.71761H4.60521C4.20891 6.71761 3.83294 6.7673 3.47729 6.87661V5.39595C3.48746 2.41476 5.95667 0 8.98477 0C12.0535 0 14.5227 2.41476 14.5227 5.39595Z",
    fill: "url(#paint1_linear_458_2)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_458_2",
    x1: 3.69364,
    y1: 6.71387,
    x2: 15.9358,
    y2: 11.3854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15C39A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09D7A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_458_2",
    x1: 5.5523,
    y1: -1.45983e-7,
    x2: 12.9639,
    y2: 3.55038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15C39A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09D7A6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/Lock.b0a4226b6341fb46b305a7f17c4fd04e.svg";
export { ForwardRef as ReactComponent };